/**
 * Ligne « Livré chez vous entre le … et le … » (fiche produit).
 * Remplit les blocs texte qui portent la classe .cf-livraison.
 * Calcul à l'heure de Paris, en jours ouvrés (lun.-ven., hors jours fériés),
 * recalculé chaque minute pour basculer tout seul après 23h.
 */
(() => {
  const CUTOFF_HOUR = 23;
  const MIN_BUSINESS_DAYS = 6;
  const MAX_BUSINESS_DAYS = 10;

  // Date et heure actuelles à Paris, quel que soit le fuseau du visiteur
  function parisNow() {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('fr-FR', {
        timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric',
        hourCycle: 'h23',
      }).formatToParts(new Date()).map((p) => [p.type, p.value])
    );
    return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour };
  }

  // Jours fériés français (dates UTC à minuit), Pâques incluses
  function holidays(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    const easter = Date.UTC(year, month - 1, day), DAY = 86400000;
    const fixed = [[0, 1], [4, 1], [4, 8], [6, 14], [7, 15], [10, 1], [10, 11], [11, 25]];
    return new Set([
      ...fixed.map(([mo, da]) => Date.UTC(year, mo, da)),
      easter + DAY, easter + 39 * DAY, easter + 50 * DAY,
    ]);
  }

  function isBusinessDay(date) {
    const wd = date.getUTCDay();
    return wd !== 0 && wd !== 6 && !holidays(date.getUTCFullYear()).has(date.getTime());
  }

  function deliveryDate(businessDays) {
    const { date, hour } = parisNow();
    if (hour >= CUTOFF_HOUR) date.setUTCDate(date.getUTCDate() + 1);
    let added = 0;
    while (added < businessDays) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (isBusinessDay(date)) added++;
    }
    return date;
  }

  // « lun. 2 nov. » ; sans le mois quand la seconde date tombe le même mois (« lun. 2 »)
  function format(date, withMonth = true) {
    return new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'UTC', weekday: 'short', day: 'numeric', ...(withMonth && { month: 'short' }),
    }).format(date);
  }

  function render() {
    const from = deliveryDate(MIN_BUSINESS_DAYS);
    const to = deliveryDate(MAX_BUSINESS_DAYS);
    const label = `${format(from, from.getUTCMonth() !== to.getUTCMonth())}|${format(to)}`;
    document.querySelectorAll('.cf-livraison').forEach((block) => {
      const target = block.querySelector('p') || block;
      if (target.dataset.cfDate === label) return;
      target.dataset.cfDate = label;
      const [start, end] = label.split('|');
      target.innerHTML = `<span>Livré chez vous entre le <strong>${start}</strong> et le <strong>${end}</strong>`
        + ' <em class="cf-livraison__free">Offerte</em></span>';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
  setInterval(render, 60000);
  document.addEventListener('shopify:section:load', render);
})();
